<template>
  <div class="topbar">
    <KeywordFilter :lookup="'zones/autocomplete'"/>
    <div class="topbar__cell">
      <counters>
        <template slot="total">{{zones.meta.total}}</template>
      </counters>
      <!--<div class="buttonset">
        <router-link class="buttonset__button btn btn--main" :to="{ name: 'add-zone' }">{{ $t('top_bar.add_new_zone') }}</router-link>
      </div>-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Autocomplete from 'common/Autocomplete';
import Counters from 'common/Counters';
import KeywordFilter from 'common/KeywordFilter';

export default {
  components: {
    Autocomplete,
    KeywordFilter,
    Counters,
  },
  data() {
    return {
    };
  },
  computed: mapGetters({
    zones: 'landlord/zones/zones',
    zonesPage: 'landlord/zones/page',
  }),
};
</script>



// WEBPACK FOOTER //
// src/components/zones/Topbar.vue